import { Injectable } from '@angular/core';
import {
  PublicDemandFormDetails,
  SendPublicDemandFormPayload,
  SendPublicDemandFormResponse,
} from '@features/public-demand-form/utils/models/public-demand-form.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class PublicDemandFormService extends HttpHandler {
  validateDemandForm(userId: number): Observable<HttpResponse<PublicDemandFormDetails>> {
    const url: string = environment.apiUrls.demands.validate;
    const params = { user_id: userId };
    return this.post<HttpResponse<PublicDemandFormDetails>>(url, params);
  }

  sendDemandForm(payload: SendPublicDemandFormPayload): Observable<HttpResponse<SendPublicDemandFormResponse>> {
    const url: string = environment.apiUrls.demands.sendPublic;
    const formData: FormData = new FormData();
    Object.entries(payload)
      .filter(([, value]) => (value instanceof Array ? value.length : value))
      .forEach(([key, value]) => {
        if (value instanceof Array) {
          value.forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else {
          formData.append(key, typeof value === 'number' ? value.toString() : value);
        }
      });
    return this.post<HttpResponse<SendPublicDemandFormResponse>>(url, formData, {
      recaptchaAction: 'submit_public_demand_form',
    });
  }
}
